import { render, staticRenderFns } from "./JMflowPlugin.vue?vue&type=template&id=dbef5182&scoped=true&"
import script from "./JMflowPlugin.vue?vue&type=script&lang=js&"
export * from "./JMflowPlugin.vue?vue&type=script&lang=js&"
import style0 from "./JMflowPlugin.vue?vue&type=style&index=0&id=dbef5182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbef5182",
  null
  
)

export default component.exports